import { createContext, useState } from "react";

export const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
    const [showSidebar, setShowSidebar] = useState(true);
    const [showHighYieldSidebar, setShowHighYieldSidebar] = useState(false);
    const [showExtendedTextbookSidebar, setShowExtendedTextbookSidebar] = useState(false);
    const [showUserProfileSidebar, setShowUserProfileSidebar] = useState(false);

    const toggleSidebar = () => {
        setShowSidebar(!showSidebar)
    };

    const toggleHighYieldSidebar = () => {
        setShowHighYieldSidebar(!showHighYieldSidebar);
    };

    const toggleExtendedTextbookSidebar = () => {
        setShowExtendedTextbookSidebar(!showExtendedTextbookSidebar);
    };

    const toggleShowUserProfileSidebar = () => {
        setShowUserProfileSidebar(!showUserProfileSidebar);
    };

    return (
        <SidebarContext.Provider value={{
            toggleSidebar,
            showSidebar, 
            setShowSidebar,
            toggleHighYieldSidebar,
            showHighYieldSidebar,
            toggleExtendedTextbookSidebar,
            showExtendedTextbookSidebar,
            toggleShowUserProfileSidebar,
            showUserProfileSidebar
        }}>
            {children}
        </SidebarContext.Provider>
    )
    
}
